export default {"src":"/_next/static/image/public/images/ic_doctor.f748b4272964d0bfb22e2f219d37ed47.svg","height":14,"width":14};